import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-comment',
  templateUrl: './icon-comment.component.html',
  styleUrls: ['./icon-comment.component.scss']
})
export class IconCommentComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
